import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import CHIKU_MOBILE from './assets/chiku-mobile.svg';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './ChikuHeroMobile.scss';

const propTypes = {
    className: PropTypes.string,
};

function ChikuHeroMobile(props) {
    const {
        className = '',
    } = props;

    return (

        <img
            alt="chiku-mobile"
            className={classNames(styles.chikuMobile, className)}
            height={66}
            src={CHIKU_MOBILE}
            width={82}
        />
    );
}

ChikuHeroMobile.propTypes = propTypes;

export {
    ChikuHeroMobile,
};
export default ChikuHeroMobile;
